var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('lei-popover',{staticClass:"container",attrs:{"text":_vm.tooltips.backTo}},[_c('div',{staticClass:"go-back",on:{"click":_vm.returnToSearch}},[_c('i',{staticClass:"arrow el-icon-arrow-left"}),_c('a',{staticClass:"link"},[_vm._v("Back to search results")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4798f688","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/record-details/BackToSearch.vue
// module id = null
// module chunks = 